module.exports = __webpack_public_path__ + "static/media/gq.6256311f.webp";